'use client';

import useSWR from 'swr';
import { LangType } from '@/lib/i18n/storage';

interface CryptoPriceParams {
  token: string;
  slug: string;
  source: 'chainlink' | 'binance';
  interval?: number;
  openTime: number;
  language?: LangType;
}

interface GammaEvent {
  startTime?: string | number | null;
  endDate?: string | number | null;
  startDate?: string | number | null;
  start_time?: string | number | null;
  end_date?: string | number | null;
}

interface TokenPriceResponse {
  data?: {
    open_price?: string | number | null;
    close_price?: string | number | null;
  };
}

export function useCryptoOpenPrice(params: CryptoPriceParams) {
  const { slug, openTime, ...rest } = params;
  const tokenPriceKey = (() => {
    if (!params.token || !openTime) return null;

    const searchParams = new URLSearchParams(
      Object.entries(rest)
        .filter(([, v]) => v !== undefined)
        .map(([k, v]) => [k, `${v}`]),
    );
    if (openTime) {
      searchParams.set('open_time', String(openTime));
    }

    return `api:/market/token-price?${searchParams.toString()}`;
  })();

  const { data } = useSWR<TokenPriceResponse>(tokenPriceKey, {
    revalidateOnFocus: false,
    revalidateOnReconnect: false,
    errorRetryCount: 0,
    dedupingInterval: 0,
    refreshWhenHidden: true,
    refreshInterval: (res) => {
      if (res?.data?.open_price != null) {
        return 0;
      }
      return 1000;
    },
  });

  return +(data?.data?.open_price || 0);
}
